import { Attributes, Misc, ModelBase, NeoModel, Validation } from '@singularsystems/neo-core';

@NeoModel
export default class UpdateInstrumentCommand extends ModelBase {

    public instrumentID: number = 0;

    public description: string = "";

    public isin: string = "";

    public ticker: string = "";

    public isListedInstrumentInd: boolean = false;

    public instrumentSubTypeID: number | null = null;

    public instrumentSubType: string = "";

    public instrumentType: string | null = null;

    @Attributes.Date(Misc.TimeZoneFormat.None)
    public maturityDate: Date | null = null;

    public isDeletedInd: boolean = false;

    public isDualListed: boolean = false;

    public isREIT: boolean = false;

    // Client only properties / methods
    protected addBusinessRules(rules: Validation.Rules<this>) {
        super.addBusinessRules(rules);
    }
}